const fontRefRegistry = new Map<string, string>();
let fontRefCounter = 0;

// Stable ref per font file: SceneRenderer dedups by ref, so a file must keep one ref across renders (else stale bytes reused).
// `instance` — the instance of a variable file the text draws by PostScript name (`instanceRefKey`: its index in
// `fvar`, or a slider-value name's axis values): the engine keys a run's variation by its font ref, as print keys a
// font by PostScript name, so two instances of one file need two refs. A static file, or a name that finds no
// instance, keeps the ref it always had.
export function fontRefFor(url: string, fontWeight: string, italic: boolean, instance?: number | string): string {
  const key = `${url}|${fontWeight}|${italic ? 'i' : ''}${instance === undefined ? '' : `|#${instance}`}`;
  let ref = fontRefRegistry.get(key);
  if (!ref) {
    ref = `f${fontRefCounter++}`;
    fontRefRegistry.set(key, ref);
  }

  return ref;
}

export function __resetFontRefRegistryForTests(): void {
  fontRefRegistry.clear();
  fontRefCounter = 0;
}
